const ORDER_DETAILS_BASE = '/mafcommercewebservices/v2/{{StoreId}}/{{language}}/users/{{userId}}';

const APIGEE_ORDER_DETAILS_BASE = `${process.env.REACT_APP_RETAIL_SSO_BASE}/v2/orders/{{StoreId}}/{{language}}`;

export const GET_ORDER_DETAILS_LIST = `/v2/orders/{{StoreId}}/{{language}}/order-history?orderCode={{orderCode}}`;

export const CHECK_SHIPMENT_CANCELLABILITY = `${ORDER_DETAILS_BASE}/order/shipment/{{consignmentId}}?app_id={{appId}}&access_token={{token}}&areaCode={{areaCode}}`;

export const CANCEL_SHIPMENT = `${APIGEE_ORDER_DETAILS_BASE}/cancelconsignment/{{consignmentId}}/cancel`;

export const GET_CANCEL_REASONS = `${APIGEE_ORDER_DETAILS_BASE}/cancel/cancelreasons`;

export const CHECK_RETURN_AVAILABILITY = `/v2/orders/{{StoreId}}/{{language}}/returns/checkreturnability`;
export const GET_PLASTIC_BAG_CONSENT = `/v2/customers/preferences?fields=username&fields=singleUseBagOpted`;
export const SET_PLASTIC_BAG_CONSENT = `/v2/customers/preferences`;

export const CHECK_MULTI_RETURN_AVAILABILITY_URL = `/v2/orders/{{StoreId}}/{{language}}/multi-returns/checkreturnability`;
